<script setup lang="ts">
import { toastsActive } from '@/components/util/toast';
</script>

<template>
  <teleport to="body" v-if="toastsActive.length > 0">
    <div class="toast-container position-fixed end-0 bottom-0 p-3">
      <div
        v-for="toast of toastsActive"
        :key="toast.id"
        class="toast align-items-center show border-0"
        :class="`text-bg-${toast.type}`"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div class="d-flex">
          <div class="toast-body">{{ toast.message }}</div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<style scoped>
.toast {
  animation: toast-fade-in 300ms ease-out 0s 1 normal forwards;
}

@keyframes toast-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
